import { Activations } from '@payu/paymentsos-types'

import { State } from '../redux/reducers/activationRegistrationUIReducer'

const CUSTOM_BILLING_PLAN = 'CUSTOM'

export const buildAccountActivationsRequest = (accountDetails: State): Activations.PostActivation => ({
  contact_information: {
    business: accountDetails.contactInformation?.business,
    development: accountDetails.contactInformation?.development,
    financial: accountDetails.contactInformation?.financial
  },
  billing_package: accountDetails.selectedPlan || CUSTOM_BILLING_PLAN,
  payment_information: {
    token: accountDetails.paymentInformation?.token
  },
  business_information: {
    company_legal_name: accountDetails.businessInformation?.companyLegalName,
    business_registration_number: accountDetails.businessInformation?.businessRegistrationNumber,
    business_address: {
      address_line: `${accountDetails.businessAddress?.addressLine1}, ${accountDetails.businessAddress?.addressLine2}`,
      city: accountDetails.businessAddress?.city,
      state: accountDetails.businessAddress?.state,
      country: accountDetails.businessAddress?.country,
      zip_code: accountDetails.businessAddress?.zipCode
    }
  }
})
export const buildInternalAccountActivationsRequest = (accountDetails: State, _isShouldSkipCRMFlow: boolean) => {
  const activationsRequest = buildAccountActivationsRequest(accountDetails)
  delete activationsRequest.payment_information
  activationsRequest.billing_package = CUSTOM_BILLING_PLAN

  if (_isShouldSkipCRMFlow) {
    // @ts-ignore: activations gateway is not typed correctly
    activationsRequest.is_crm_flow = false
  }

  return activationsRequest
}
